import React, { useContext } from 'react';
import { useI18n } from '@whizz/react-i18n';
import type { HighlightedProps } from '../../types';
import { SectionLayout } from '../modules';
import { Button, TopicProgress as TopicProgressChart } from '../../../components';
import { GLOBAL_ICONS, ROUTES } from '../../../util/vars';
import type { TopicChartType } from '../../../mapper/groupTopicReportMapper';
import { PdfContext } from '../../../context/PdfContext';
import TrackVisibility from 'react-on-screen';

type Props = {
  chartTopicProgress: TopicChartType[],
  showOthersData: boolean,
  showSensitiveData?: boolean
} & HighlightedProps;

const TopicProgress = (
  {
    chartTopicProgress,
    showOthersData,
    showSensitiveData = true,
    highlightedLabel,
    highlightedIds,
  }: Props,
): JSX.Element => {
  const { translate } = useI18n();

  const { isPdf } = useContext(PdfContext);

  const topicFocusButton =
      <a href={ROUTES.topic_focus}>
        <Button
          color={'white'}
          icon={GLOBAL_ICONS.topic_focus}
          data-hide-print
        >
          {translate('pages.TOPIC.SET.MODAL.title')}
        </Button>
      </a>;

  return (
    <SectionLayout
      title={translate('pages.REPORTS.SECTIONS.TOPIC_PROGRESS.title')}
      highlightLabel={highlightedLabel}
      moreInfo={translate('pages.REPORTS.SECTIONS.TOPIC_PROGRESS.info', { 'interpolation': { 'escapeValue': false } })}
      canBeExpanded={false}
      data-cy="topic-progress"
      id='topic-progress-container'
      className={'pdf-no-break'}
      additionalAction={!isPdf && topicFocusButton}
    >
      <TrackVisibility partialVisibility>
        {({ isVisible }) => (
          <TopicProgressChart
            showOthersData={showOthersData}
            showSensitiveData={showSensitiveData}
            topics={chartTopicProgress}
            highlightedIds={highlightedIds}
            play={isVisible}
          />)
        }
      </TrackVisibility>
    </SectionLayout>
  );
};

TopicProgress.displayName = 'TopicProgress';

export default TopicProgress;
